export function todayIsoDate() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function normalizeCalendarEntry(entry, index) {
  if (!entry) return null;
  if (entry.type === 'appointment') {
    const startTime = String(entry.start_time || '').trim();
    const endTime = String(entry.end_time || '').trim();
    if (!startTime || !endTime) return null;
    return {
      id: entry.id || `appointment-${index}`,
      type: 'appointment',
      date: entry.date || todayIsoDate(),
      start_time: startTime,
      end_time: endTime,
      text: String(entry.text || '').trim(),
    };
  }
  const text = String(entry.text || '').trim();
  if (!text) return null;
  return {
    id: entry.id || `legacy-${index}`,
    type: 'note',
    date: entry.date || todayIsoDate(),
    text,
  };
}

export function isAppointmentEntry(entry) {
  return entry?.type === 'appointment';
}

export function getProspectNotesEntries(prospect) {
  return getProspectCalendarEntries(prospect).filter((entry) => !isAppointmentEntry(entry));
}

export function getProspectCalendarEntries(prospect) {
  if (!prospect) return [];
  if (Array.isArray(prospect.notes_entries) && prospect.notes_entries.length > 0) {
    return prospect.notes_entries
      .map((entry, index) => normalizeCalendarEntry(entry, index))
      .filter(Boolean);
  }
  const raw = prospect.notes;
  if (!raw || !String(raw).trim()) return [];
  const text = String(raw).trim();
  if (text.startsWith('[')) {
    try {
      const parsed = JSON.parse(text);
      if (Array.isArray(parsed)) {
        return parsed
          .map((entry, index) => normalizeCalendarEntry(entry, index))
          .filter(Boolean);
      }
    } catch {
      // fall through to plain text
    }
  }
  return [{ id: 'legacy-0', type: 'note', date: todayIsoDate(), text }];
}

export function groupNotesByDate(entries) {
  return groupCalendarEntriesByDate(entries);
}

export function groupCalendarEntriesByDate(entries) {
  const grouped = {};
  for (const entry of entries || []) {
    const date = entry?.date || todayIsoDate();
    if (!grouped[date]) grouped[date] = [];
    grouped[date].push(entry);
  }
  return grouped;
}

export function formatTimeRange(startTime, endTime, locale) {
  if (!startTime || !endTime) return '—';
  const formatTime = (value) => {
    const [hour, minute] = String(value).split(':').map(Number);
    const date = new Date(2000, 0, 1, hour, minute);
    return date.toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit' });
  };
  return `${formatTime(startTime)} – ${formatTime(endTime)}`;
}

export function formatNoteDate(value, locale) {
  if (!value) return '—';
  const parts = String(value).split('-');
  if (parts.length === 3) {
    const date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    if (!Number.isNaN(date.getTime())) {
      return date.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    }
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
